import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import NotificationsPage from './NotificationsPage';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { NotificationsType } from 'src/reducers/landingPage';
import { getNotifications, readAllNotification, readNotifications } from 'src/actions/landingPageAction';
import { rowClick, rowFbStatusClick } from 'src/actions/completeOrderAction';

export const mapStateToProps = (state: AppState) => {
  return {
    notifications: state.landingPage.notifications,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onComponentDidMount: () => {
      // dispatch(getUserPaidInvoiceData());
    },
    onComponentWillMount: () => {
      dispatch(doCheckAuthentication);
    },
    readNotification: (notification: NotificationsType) => {
      dispatch(readNotifications(notification));
    },
    reload: () => {
      dispatch(getNotifications);
    },
    readAllNotification: () => {
      dispatch(readAllNotification);
    },
    onRowClick: (notification: NotificationsType) => {
      const { feedback } = notification;
      dispatch(rowClick(notification.orderno, notification.dsordersid, feedback));
      // dispatch(readNotifications(notification));
    },
    onRowClickFbStatus: (orderid: string, rowData: string, feedbackreview: string) => {
        dispatch(rowFbStatusClick(orderid, rowData, feedbackreview));
    },
  };
};

const NotificationsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationsPage);

export default NotificationsContainer;



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationsContainer.tsx